export const DownTrend = () => {
    return (
        <svg height="10" viewBox="0 0 64 64" width="10" xmlns="http://www.w3.org/2000/svg" id="fi_10124720">
            <g id="Layer_3">
                <path d="m54.01 21.625-15.009 15.302v-36.927h-14.002v36.927l-15.009-15.302-9.991 9.749 31.999 32.626 32.003-32.626z" fill="#ef3333"></path>
            </g>
        </svg>
    );
};